import { selector } from "recoil"

import { clientState } from "./clientState"
import { companyState } from "./companyState"
import { recruitsState } from "./recruitsState"

export const isClientNotFoundState = selector<boolean>({
  key: "isClientNotFoundFound",
  get: ({ get }) => !get(clientState),
})

export const isCompanyNotFoundState = selector<boolean>({
  key: "isCompanyNotFound",
  get: ({ get }) => !get(companyState),
})

export const isRecruitNotFoundState = selector<boolean>({
  key: "isRecruitNotFound",
  get: ({ get }) => get(recruitsState).length === 0,
})
